import styled from "styled-components";

export const DashboardBox = styled.div`
  background: #ffffff;
  box-shadow: 0px 13px 15px rgba(11, 27, 83, 0.08);
  border-radius: 10px;
  border: 1px solid #dfdfdf;
`;
